import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import React from 'react';
import { useStaticQuery } from 'gatsby';
import { parseISO } from 'date-fns';
import Card from './Card';
import './recommended-posts.scss';
var query = "3768944461";
export var RecommendedPosts = function RecommendedPosts(_ref) {
  _objectDestructuringEmpty(_ref);

  var data = useStaticQuery(query);
  var edges = data.allWpNews.edges;
  return /*#__PURE__*/React.createElement("div", {
    className: "recommended-posts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "box has-text-centered header"
  }, /*#__PURE__*/React.createElement("h4", null, "Ieteiktie raksti")), /*#__PURE__*/React.createElement("div", {
    className: "posts"
  }, edges.map(function (_ref2, i) {
    var _node$title, _node$post_preview$pr, _node$post_preview, _node$post_preview$pr2, _node$post_preview$pr3, _node$post_preview2, _node$post_preview2$p, _node$slug, _parseISO;

    var node = _ref2.node;
    return /*#__PURE__*/React.createElement("div", {
      className: "box",
      key: i
    }, /*#__PURE__*/React.createElement(Card, {
      title: (_node$title = node.title) !== null && _node$title !== void 0 ? _node$title : '',
      image: {
        url: (_node$post_preview$pr = (_node$post_preview = node.post_preview) === null || _node$post_preview === void 0 ? void 0 : (_node$post_preview$pr2 = _node$post_preview.previewImage) === null || _node$post_preview$pr2 === void 0 ? void 0 : _node$post_preview$pr2.sourceUrl) !== null && _node$post_preview$pr !== void 0 ? _node$post_preview$pr : '',
        alt: (_node$post_preview$pr3 = (_node$post_preview2 = node.post_preview) === null || _node$post_preview2 === void 0 ? void 0 : (_node$post_preview2$p = _node$post_preview2.previewImage) === null || _node$post_preview2$p === void 0 ? void 0 : _node$post_preview2$p.altText) !== null && _node$post_preview$pr3 !== void 0 ? _node$post_preview$pr3 : ''
      },
      path: (_node$slug = node.slug) !== null && _node$slug !== void 0 ? _node$slug : '',
      date: (_parseISO = parseISO(node.date)) !== null && _parseISO !== void 0 ? _parseISO : new Date()
    }));
  })));
};
export default RecommendedPosts;